/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Import_FileInputs */



/**
* | output |
* | --- |
* | "Open the import file menu" |
*
* @param {Shortcut_Keys_Desc_Import_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_import_file = /** @type {((inputs?: Shortcut_Keys_Desc_Import_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Import_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le menu d'import")
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffnen Sie das Menü „Datei importieren“.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri il menu di importazione del file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Откройте меню импорта файла.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abra el menú de archivo de importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开导入文件菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポートファイルメニューを開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात फ़ाइल मेनू खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra o menu de importação de arquivos")
	return /** @type {LocalizedString} */ ("Open the import file menu")
});